import { Check, X } from "lucide-react";
import { Reveal, MaskLines, Eyebrow } from "./motion";

const YES = ["Quer ter o seu próprio negócio", "Tem mentalidade empreendedora", "Procura método e acompanhamento", "Valoriza tecnologia e inovação", "Quer crescer integrado numa rede", "Está disposto a liderar pessoas"];
const NO = ["Procura resultados fáceis", "Não está disponível para aprender", "Não acredita em trabalho em equipa", "Procura apenas uma marca"];

const Item = ({ ok, text, i }) => (
  <Reveal as="li" delay={i * 0.06} className="group flex items-start gap-4 border-b border-current/10 py-4">
    <span className={`mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-full transition-transform duration-300 group-hover:scale-110 ${ok ? "bg-orange text-white" : "bg-ink/10 text-ink"}`}>
      {ok ? <Check className="h-4 w-4" strokeWidth={3} /> : <X className="h-4 w-4" strokeWidth={3} />}
    </span>
    <span className="font-display text-lg font-bold sm:text-xl">{text}</span>
  </Reveal>
);

export const ForWho = () => (
  <section id="para-quem" className="bg-paper py-24 text-ink sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Eyebrow num="08">Para quem é esta oportunidade?</Eyebrow>
      <h2 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
        <MaskLines lines={["Não é para todos.", <span className="text-orange-deep">E ainda bem.</span>]} />
      </h2>
      <div className="mt-16 grid gap-6 lg:grid-cols-12">
        <div className="rounded-[28px] bg-white p-7 shadow-[0_30px_80px_-40px_rgba(8,18,38,0.35)] sm:p-10 lg:col-span-7" data-testid="for-who-yes">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-orange-deep">Esta oportunidade é para si se:</p>
          <ul className="mt-6">{YES.map((t, i) => <Item key={t} ok text={t} i={i} />)}</ul>
        </div>
        <div className="rounded-[28px] border border-ink/15 p-7 sm:p-10 lg:col-span-5" data-testid="for-who-no">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-slate-500">Esta oportunidade não é para si se:</p>
          <ul className="mt-6 text-slate-600">{NO.map((t, i) => <Item key={t} text={t} i={i} />)}</ul>
        </div>
      </div>
    </div>
  </section>
);
